import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	label: {
		id: 'card.common.context-menu.trigger-label',
		defaultMessage: 'Open card actions menu',
		description: 'Aria label for card context menu',
	},
});
